import * as React from "react";
import { Button, ButtonGroup } from "@/components/ui";
import { cn } from "@/lib/utils";

export interface ScopeToggleProps {
  scope: "global" | "coach";
  onScopeChange(scope: "global" | "coach"): void;
}

const OPTIONS = [
  { value: "global", label: "Global" },
  { value: "coach", label: "Coach" },
] as const;

/** Global | Coach as a segmented control: it filters what's shown, so it shouldn't read as page tabs. */
export const ScopeToggle: React.FC<ScopeToggleProps> = ({ scope, onScopeChange }) => (
  <ButtonGroup aria-label="Scope" className="rounded-lg border border-slate-200 bg-white p-0.5">
    {OPTIONS.map(option => {
      const active = scope === option.value;
      return (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={active ? "secondary" : "ghost"}
          aria-pressed={active}
          className={cn(active && "shadow-xs")}
          onClick={() => onScopeChange(option.value)}
        >
          {option.label}
        </Button>
      );
    })}
  </ButtonGroup>
);
